import { ApiSuggestResponse, PostcodeResponse } from './types';

interface ErrorResponse {
  status: string;
  messages: string[];
}

export interface ApiResponse {
  status: string;
  messages?: string[];
  result?: unknown;
  data?: unknown;
}

export default (function () {
  const genericError: ErrorResponse = {
    status: 'error',
    messages: [
      'Upps, es gab ein technisches Problem. Bitte versuche es einfach etwas später noch einmal oder melde dich bei unserem Team im Service Bereich.',
    ],
  };

  const networkError: ErrorResponse = {
    status: 'error',
    messages: ['Keine Netzwerk Verbindung.'],
  };

  const abortedError: ErrorResponse = {
    status: 'aborted',
    messages: ['Aborted.'],
  };

  let aborter: AbortController | null = null;

  async function post(
    url = '',
    data: Record<string, unknown> = {},
  ): Promise<ApiResponse | ApiSuggestResponse | PostcodeResponse> {
    let result: ApiResponse | ApiSuggestResponse | PostcodeResponse;

    if (aborter) aborter.abort();
    aborter = new AbortController();
    const signal = aborter.signal;

    await fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      signal: signal,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(data),
    })
      .catch((err: Error) => {
        console.log('err', err); // TODO: remove?
        const err_string = err.toString();
        if (err_string && err_string.indexOf('aborted') !== -1) {
          result = abortedError;
        }
        if (err_string && err_string.indexOf('aborted') === -1) {
          result = networkError;
        }

        // return;
      })
      .then((response) => response && response.json())
      .then((data: ApiResponse) => {
        result = data;
      })
      .catch((err: Error) => {
        console.log('err', err); // TODO: remove?
        if (!result) result = genericError;
      });

    return result!;
  }

  async function get(
    url = '',
  ): Promise<ApiResponse | ApiSuggestResponse | PostcodeResponse> {
    let result: ApiResponse | ApiSuggestResponse | PostcodeResponse;

    await fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .catch((err: Error) => {
        console.log('err', err);

        const err_string = err.toString();
        if (err_string && err_string.indexOf('aborted') !== -1) {
          result = abortedError;
        }
        if (err_string && err_string.indexOf('aborted') === -1) {
          result = networkError;
        }
      })
      .then((response) => response && response.json())
      .then((data: ApiResponse) => {
        result = data;
      })
      .catch((err: Error) => {
        console.log('err', err); // TODO: remove?
        if (!result) result = genericError;
      });

    return result!;
  }

  async function put(
    url = '',
    data: Record<string, unknown> = {},
  ): Promise<ApiResponse | ApiSuggestResponse> {
    let result: ApiResponse | ApiSuggestResponse;

    await fetch(url, {
      method: 'PUT',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(data),
    })
      .catch((err: Error) => {
        console.log('err', err);
        if (!result) result = genericError;
      })
      .then((response) => response && response.json())
      .then((data: ApiResponse) => {
        result = data;
      })
      .catch((err: Error) => {
        console.log('err', err);
        if (!result) result = genericError;
      });

    return result!;
  }
  return {
    get,
    post,
    put,
  };
})();
